import { useState } from "react";
import { toast } from "sonner";
import { createGuideCheckout } from "@/lib/jobbkartaApi";

export function useBuyGuide() {
  const [loading, setLoading] = useState(false);
  const buy = async () => {
    setLoading(true);
    try {
      const { checkout_url } = await createGuideCheckout(window.location.origin);
      window.location.href = checkout_url;
    } catch (e) {
      toast.error("Kunde inte öppna betalningen. Försök igen.");
      setLoading(false);
    }
  };
  return { buy, loading };
}
